import script from "./PostbackChecker.vue?vue&type=script&setup=true&lang=js"
export * from "./PostbackChecker.vue?vue&type=script&setup=true&lang=js"

import "./PostbackChecker.vue?vue&type=style&index=0&id=705270ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705270ce"]])

export default __exports__